import cmsAdapter from "../../common/Adapters/CMSAdapter/CMSAdapter";
import { useEffect, useState } from "react";

export default function useCMSSearch(language, text) {
  const [mediaItems, setMediaItems] = useState(null);
  const [videoItems, setVideoItems] = useState(null);
  const [employeeItems, setEmployeeItems] = useState(null);
  const [articlesAndPages, setArticlesAndPages] = useState(null);
  const [vorstandItems, setVorstandItems] = useState(null);
  const [aliasItems, setAliasItems] = useState(null);

  const getArticlesAndPages = async () => {
    const result = await cmsAdapter.fetchSearchArticlesAndPages(language, text);
    setArticlesAndPages(result);
  };

  const getMediaItems = async () => {
    const result = await cmsAdapter.fetchSearchMedia(language, text);
    setMediaItems(
      result?.map((el) => ({
        ...el,
        download: el.download[0],
      }))
    );
  };

  const getVideoItems = async () => {
    const result = await cmsAdapter.fetchSearchVideos(language, text);
    setVideoItems(result);
  };

  const getEmployeeItems = async () => {
    const result = await cmsAdapter.fetchSearchEmployees(language, text);
    setEmployeeItems(result);
  };

  const getVorstandItems = async () => {
    const result = await cmsAdapter.fetchSearchVorstandItems(language, text);
    setVorstandItems(result);
  };

  const getAliasItems = async () => {
    const result = await cmsAdapter.fetchSearchAliasItems(language, text);
    setAliasItems(result);
  };
  const resetStates = () => {
    setMediaItems(null);
    setVideoItems(null);
    setEmployeeItems(null);
    setArticlesAndPages(null);
    setVorstandItems(null);
    setAliasItems(null);
  };
  useEffect(() => {
    if (text && language) {
      resetStates();
      getMediaItems();
      getVideoItems();
      getArticlesAndPages();
      getEmployeeItems();
      getVorstandItems();
      getAliasItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, text]);

  return {
    mediaItems,
    videoItems,
    employeeItems,
    articlesAndPages,
    vorstandItems,
    aliasItems,
  };
}
